<template lang="html">
  <div class="row">
    <div class="col-md-12">
      <awards-new></awards-new>
      <awards-list></awards-list>
    </div>
  </div>
</template>

<script>
import AwardsList from './AwardsList'
import AwardsNew from './AwardsNew'
export default {
  data () {
    return {}
  },
  computed: {},
  methods: {},
  components: {
    AwardsList,
     AwardsNew
  }
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** AwardsHome.vue?f660436e
 **/